function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1124.332,652.537a5.026,5.026,0,1,0-7.606,0,10.036,10.036,0,0,0-6.25,9.293.585.585,0,0,0,.03.139h20.069A10,10,0,0,0,1124.332,652.537Zm-3.8-5.768a2.511,2.511,0,0,1,.054,5.022c-.018,0-.036,0-.054,0s-.035,0-.053,0a2.511,2.511,0,0,1,.053-5.022Zm-7.148,12.685a7.544,7.544,0,0,1,7.095-5.15c.018,0,.035.006.053.006s.035-.006.054-.006a7.542,7.542,0,0,1,7.1,5.15Zm22.229-18.85v2.513h-3.77v3.77h-2.514v-3.77h-3.77V640.6h3.77v-3.77h2.514v3.77Z",
  transform: "translate(-1110.476 -636.834)",
  fill: "#b40000"
});

var SvgProfilePlus = function SvgProfilePlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.134,
    height: 25.134,
    viewBox: "0 0 25.134 25.134",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfilePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-plus.39162f85.svg";
export { ForwardRef as ReactComponent };